// src/utils/helpers.js

export function calcDeposit(price, pct) {
  return Math.round(price * pct / 100);
}

export function formatDate(dateStr) {
  if (!dateStr) return "";
  try {
    return new Intl.DateTimeFormat("ar-EG", {
      year: "numeric", month: "short", day: "numeric",
    }).format(new Date(dateStr));
  } catch {
    return dateStr;
  }
}

export function formatTimestamp(ts) {
  if (!ts) return "";
  try {
    const date = ts.toDate ? ts.toDate() : new Date(ts.seconds ? ts.seconds * 1000 : ts);
    return new Intl.DateTimeFormat("ar-EG", {
      year: "numeric", month: "short", day: "numeric",
      hour: "2-digit", minute: "2-digit",
    }).format(date);
  } catch {
    return "";
  }
}

export function minutesAgo(ts) {
  if (!ts) return 0;
  try {
    const date = ts.toDate ? ts.toDate() : new Date(ts.seconds ? ts.seconds * 1000 : ts);
    return Math.floor((Date.now() - date.getTime()) / 60000);
  } catch {
    return 0;
  }
}

export function timeLeftMins(ts, limitMin) {
  return Math.max(0, (limitMin || 0) - minutesAgo(ts));
}

export function formatMins(m) {
  if (m >= 60) return `${Math.floor(m / 60)}س ${m % 60}د`;
  return `${m}د`;
}

export const STATUS_CONFIG = {
  pending:            { label: "قيد البحث",               color: "#92400E", bg: "#FEF3C7", dot: "#F59E0B" },
  awaiting_deposit:   { label: "انتظار الديبوزت",          color: "#1E40AF", bg: "#DBEAFE", dot: "#3B82F6" },
  deposit_review:     { label: "مراجعة التحويل",            color: "#6D28D9", bg: "#EDE9FE", dot: "#7C3AED" },
  confirmed:          { label: "مؤكدة",                    color: "#065F46", bg: "#D1FAE5", dot: "#10B981" },
  captain_completed:  { label: "انتظار تأكيد الإتمام",      color: "#92400E", bg: "#FEF9C3", dot: "#EAB308" },
  completed:          { label: "مكتملة",                   color: "#1E3A5F", bg: "#BFDBFE", dot: "#3B82F6" },
  cancelled:          { label: "ملغاة",                    color: "#991B1B", bg: "#FEE2E2", dot: "#EF4444" },
  expired:            { label: "انتهت المهلة",               color: "#374151", bg: "#F3F4F6", dot: "#9CA3AF" },
};
